<template>
  <div class="live-wrapper">
    <van-list v-if="list.length"  v-model="loading" :finished="finished" :immediate-check="immediate" :finished-text="finishedTxt" @load="moreList">
      <div class="job-zt-list-1">
        <div class="item-box" v-for="(item,index) in list" :key="index">
          <div class="item" @click="goDes(item)">
            <!--            <router-link>-->
            <img alt="" v-lazy="item.image" />
            <div class="top-box justify-align">
              <div class="top-lf left-justifying" style="padding: 0;">
                <!--                <template v-if="item.live_status==1">-->
                <!--                  <img src="../../assets/zhiboz_icon.png" alt="" />-->
                <!--                  <span>直播中</span>-->
                <!--                </template>-->
                <!--                <template v-else-if="item.live_status==2">-->
                <!--                  <img src="../../assets/zhibo_huo.png" alt="" />-->
                <!--                  <span>热播</span>-->
                <!--                </template>-->
                <!--                <template v-else-if="item.live_status==3">-->
                <!--                  <img src="../../assets/zhibo_huo.png" alt="" />-->
                <!--                  <span>热搜</span>-->
                <!--                </template>-->
                <!--                <template v-else-if="item.zhibo_new==4">-->
                <!--                  <img src="../../assets/zhibo_huo.png" alt="" />-->
                <!--                  <span>首发</span>-->
                <!--                </template>-->
                <!--                <template v-else-if="item.zhibo_new==5">-->
                <!--                  <img src="../../assets/vip_icon.png" alt="" />-->
                <!--                  <span>VIP</span>-->
                <!--                </template>-->
                <!--                <template v-else-if="item.zhibo_new==6">-->
                <!--                  <img src="../../assets/zhibo_vr.png" alt="" />-->
                <!--                  <span>VR</span>-->
                <!--                </template>-->
              </div>
              <div class="top-rt left-justifying" v-if="item.likes">
                <div class="xin-icon-box"><img :src="require('../../assets/'+appTheme+'/xin_zhibo.png')" alt="" /></div>{{item.likes}}</div>

            </div>
            <div class="title-box">
              <div class="title-txt">{{item.title}}</div>
            </div>
            <!--            </router-link>-->
          </div>
        </div>
      </div>
    </van-list>
    <van-popup v-model="apply_for_show" closeable :overlay="false">
      <div class="popup-content">
        <div class="phone-txt content-center">
          <img :src="require('../../assets/'+appTheme+'/f_phone.png')" alt="" />
          联系电话
        </div>
        <div class="phone-num content-center"><div style="padding: 2.66667vw 1.33333vw" @click="callPhone">4000960592</div> 冯飞 <img :src="require('../../assets/'+appTheme+'/f_pointer.png')" alt="" /></div>
      </div>
    </van-popup>
    <div class="null-box"></div>
    <!--    <div class="tab-bar-box">-->
    <!--      <div class="tab-bar-box-content justify-align">-->
    <!--        <div class="tab-item content-center" @click="goHome">-->
    <!--          <img src="../../assets/f_home.png" alt="" />首页-->
    <!--        </div>-->
    <!--        <div class="tab-item content-center" @click="showPopup">-->
    <!--          <img src="../../assets/f_apply_for.png" alt="" />申请探厂-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import Vue from 'vue';
import { Lazyload } from 'vant';
Vue.use(Lazyload);
import { getListData } from '@/api/factory'
export default {
  name: "factoryList",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      apply_for_show:false,
      list: [],
      cover_img: require('@/assets/live-img.jpg'),
      loading: false, // 加载状态
      finished: false, // 是否加载
      page: 1,
      currentPage: 1,
      immediate: false,
      finishedTxt: '没有更多了~',
      statusType: 'null',
      tel:'4000960592'
    }
  },
  beforeCreate() {		//在页面创建之前设置body的背景色
    document.querySelector('body').setAttribute('style', 'background: #fff;')
  },
  beforeDestroy() {		//在页面销毁之前移除body的属性，目的是设置的颜色只对当前页面有效
    document.querySelector('body').removeAttribute('style')
  },
  beforeRouteLeave(to, from, next) { // 列表页面跳转到 详情页时，设置需要缓存 to: 即将要进入的目标 用一种标准化的方式 //from: 当前导航正要离开的路由 用一种标准化的方式
    // 去除背景色
    // console.log('离开界面')
    if (to.path == "/factoryDes2") {
      //当离开的时候不是去首页的时候开启缓存
      console.log('meta',from.meta)
      from.meta.isBack = true;
    }else {
      from.meta.isBack = false;
    }
    next()
  },
  // 列表页面
  activated() {
    if (!this.$route.meta.isBack) { // 后续进入：beforeRouteEnter => activated => deactivated,
      //isBack 时添加中router中的元信息，判读是否要缓存
      this.resetQuery(); //清空原有数据
      this.getList(); // 重新加载
      if (this.$route.query.name){
        window.document.title = this.$route.query.name // res.data.desc
        this.$route.meta.title= this.$route.query.name
      }
    }
    this.$route.meta.isBack = false; // 通过这个控制刷新，否则会一直为true
  },
  created() {
    // this.getList()
  },
  methods:{
    resetQuery() {//清空原有数据
      this.apply_for_show = false
      this.list= []
      this.loading= false // 加载状态
      this.finished= false // 是否加载
      this.page = 1
      this.currentPage= 1
      this.immediate = false
      this.finishedTxt='没有更多了~'
      this.statusType='null'

    },
    callPhone () { // 拨号
      window.location.href = 'tel:4000960592'
    },
    showPopup() {
      this.apply_for_show = true;
    },
    goDes(item){
      // console.log(id,type)
      // this.$router.push({path:'/factoryDes',query: {id:item.id}})
      this.$router.push({path:'/factoryDes2',query: {id:item.id}})
    },
    goHome(){
      this.$router.push('/');
    },
    getList(){
      var that = this
      var data = {
        page:1
      }
      getListData(data).then(res => {
        if(res.code == 200)
        {
          // console.log('res',res.data.data)
          that.list = res.data.data
          // 加载状态结束
          this.loading = false;

          if (res.data.data.length == res.data.total){ // 数据全部加载完
            that.finished = true; // 数据全部加载完
            if(res.data.data==0){
              this.finishedTxt = '暂无数据~'
            } else {
              this.finishedTxt = '没有更多了~'
            }
          }else {
            that.finished = false; // 不可以加载
          }
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    moreList(){
      var that = this
      this.currentPage += 1;//页数+1
      var data = {
        page:this.currentPage
      }
      getListData(data).then(res => {
        if(res.code == 200)
        {

          var arr = this.list.concat(res.data.data);
          that.list = arr
          // 加载状态结束
          this.loading = false;
          if (that.list.length == res.data.total) { // 数据全部加载完成

            this.finished = true;
            console.log('加载完毕')
          } else {
            this.finished = false;
          }
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.popup-content{
  padding: 60px 0;width: 500px;
  .phone-txt{
    font-size: 32px;font-weight: 400;
    color: #70AC4C;
    img{
      width: 26px;height: auto;display: inline-block;margin-right: 10px;
    }
  }
  .phone-num{
    font-size: 30px;color: #151515;font-weight: 400;padding: 20px 0;
    img{
      width: 40px;height: auto;display: inline-block;margin-left: 10px;
    }
  }
}
.van-popup--center{
  border-radius: 15px;
}
.tab-bar-box{
  position: fixed;left: 0;bottom: 0;
  width: 100%;
  padding: 40px 0;color: #282828;font-size: 32px;
  background: #fff;
  .tab-bar-box-content{
    .tab-item{
      width: 50%;
      img{
        width: 52px;height: auto;display: inline-block;margin-right: 15px;
      }
    }
  }
}
.job-zt-list-1 {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-align: center;
  align-items: center;
  padding: 1px;
  .item-box {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    text-align: center;
    .item{
      position: relative;
      //width: 100%;
      overflow: hidden;
      margin: 15px 20px 15px 0;
      //height: 512px;

      //width: 342px;
      height: 540px;
      border-radius: 20px;
      a{
        display: block;
      }
      img {
        width: 100%;display: block; height: 540px; border-radius: 20px;
      }
      .title-box{
        //padding-top: 20px;
        background: linear-gradient(transparent,#000);
        width: 100%;
        position: absolute;
        right: 0;
        bottom: 0;
        color: #fff;
        .zan-box{
          text-align: left;
          padding-left: 15px;
          position: relative;
          //justify-content: flex-end;
          //align-items: self-end;
          img{
            width: 38px;
            height: auto;display: inline-block;margin-right: 5px;
          }
        }
        .title-txt{
          overflow: hidden;
          padding: 5px 15px 5px;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: left;font-size: 28px;
        }
      }
      .top-box{
        position: absolute;top: 10px;width: 100%;left: 0;color: #FFFFFF;font-size: 20px;
        img{
          width: 32px;height: auto;display: inline-block;
        }
        .top-lf{
          //width: 96px;
          padding: 5px 10px;
          background: #F03926;
          border-radius: 20px;margin-left: 10px;
        }
        .top-rt{
          padding: 5px 10px;
          background: rgba(0, 0, 0, 0.5);
          border-radius: 20px;margin-right: 10px;
          .xin-icon-box{
            padding: 5px 8px;
            background: #F23926;margin-right: 5px;
            opacity: 0.99;
            border-radius: 50%;
            img{
              width: 18px;
              height: 16px;
            }
          }
        }
      }
    }
  }
  .item-box:nth-child(odd) .item{
    margin-left: 15px;
  }
}

</style>
